// Which tours a user has already been shown. Stored per browser so a tour
// auto-runs once and is thereafter opt-in via the help panel.

const SEEN_KEY = "pca-tours-seen";
const DISABLED_KEY = "pca-tours-disabled";

const read = (key, fallback) => {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
};

const write = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable — tours simply re-offer next session */
  }
};

export const getSeenTours = () => {
  const seen = read(SEEN_KEY, []);
  return Array.isArray(seen) ? seen : [];
};

export const hasSeenTour = (id) => getSeenTours().includes(id);

export const markTourSeen = (id) => {
  const seen = getSeenTours();
  if (!seen.includes(id)) write(SEEN_KEY, [...seen, id]);
};

// Set when someone dismisses a tour with "Don't show these again". Manual
// starts from the help panel still work — this only suppresses auto-start.
export const areToursDisabled = () => read(DISABLED_KEY, false) === true;
export const setToursDisabled = (disabled) => write(DISABLED_KEY, disabled === true);

export const resetTours = () => {
  write(SEEN_KEY, []);
  write(DISABLED_KEY, false);
};
